export default "__VITE_ASSET__Coq48t2J__"